import LocalProvider from "./reactContext/providers/LocalProvider"
import SessionProvider from "./reactContext/providers/SessionProvider"
import NwDashboardProvider from "./reactContext/providers/NwDashboardProvider"
import TeamProvider from "./reactContext/providers/TeamProvider"
import LexiconsProvider from "./reactContext/providers/LexiconsProvider"
import StProjectsProvider from "./reactContext/providers/StProjectsProvider"
import StWorkflowProvider from "./reactContext/providers/StWorkflowProvider"
import EcpProjectsProvider from "./reactContext/providers/EcpProjectsProvider"
import EcpWorkflowProvider from "./reactContext/providers/EcpWorkflowProvider"

export default function AppProviders({children}) {
    return (
        <LocalProvider>
            <SessionProvider>
                <NwDashboardProvider>
                    <TeamProvider>
                        <LexiconsProvider>
                            <StProjectsProvider>
                                <StWorkflowProvider>
                                    <EcpProjectsProvider>
                                        <EcpWorkflowProvider>
                                            {children}
                                        </EcpWorkflowProvider>
                                    </EcpProjectsProvider>
                                </StWorkflowProvider>
                            </StProjectsProvider>
                        </LexiconsProvider>
                    </TeamProvider>
                </NwDashboardProvider>
            </SessionProvider>
        </LocalProvider>
    )
}